// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".basic{background:#f7f7f7;width:100%;padding:1.875rem 0 3.125rem}.basic__title{margin-bottom:2.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
